import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { SERVICES_GRID } from '../data/scrapeData';

const SERVICE_DETAILS = {
  'stobningsarbejde': {
    title: 'Støbningsarbejde',
    subtitle: 'Din lokale Vognmand & Entreprenør.',
    metaTitle: 'Støbningsarbejde – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Støbningsarbejde - Vi kan også tilbyde støbearbejdet. støbning af fundament og sokkel, støbning af diverse.',
    intro: 'Vi kan også tilbyde støbearbejdet.',
    items: [
      'støbning af fundament og sokkel',
      'støbning af diverse.'
    ],
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/grundstobning.jpg',
    showBottomCards: true
  },
  'anlaegsopgaver': {
    title: 'Anlægsopgaver',
    subtitle: 'Din lokale Vognmand & Entreprenør.',
    metaTitle: 'Anlægsopgaver – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Anlægsopgaver: Står du og skal have lavet indkørsel, have, p-plads mm. Kan vi være behjælpelige.',
    intro: 'Står du og skal have lavet indkørsel, have, p-plads mm.',
    items: [
      'Kan vi være behjælpelige med bortkørsel af gamle materialer.',
      'Levering af nye materialer',
      'Lave klar til belægning',
      'Lave belægning',
      'Afretning af muld/sand mm.',
      'Diverse mm.'
    ],
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/udjaevne-leveret-materiale.jpg',
    showBottomCards: true
  },
  'kloak-og-jordarbejde': {
    title: 'Kloak- og jordarbejde​',
    subtitle: 'Din lokale Vognmand & Entreprenør.',
    metaTitle: 'Kloak- og jordarbejde​ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Kloak- og jordarbejde: afgravning og etablering af byggefelt, udgravning af fundament, Opbygning af sandpude, mm.',
    intro: 'Vi udfører også:',
    items: [
      'afgravning og etablering af byggefelt',
      'udgravning af fundament',
      'Opbygning af sandpude',
      'etablering af omfangsdræn',
      'alt kloakarbejde og regnvandsafledning'
    ],
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/kloak-arbejde.jpg',
    showBottomCards: true
  },
  'vognmandskorsel-2': {
    title: 'Vognmandskørsel​',
    metaTitle: 'Vognmandskørsel​ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi leverer alle former for materialer: Sand/bundsikring, Grus, Knust beton, Muld, Halm / korn kørsel og meget mere.',
    intro: 'Vi leverer alle former for materialer:',
    items: [
      'Sand/bundsikring',
      'Grus',
      'Knust beton',
      'Muld',
      'Halm / korn kørsel'
    ],
    closing: 'og meget mere.\n\nKøb / salg / formidling af halm tilbydes.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-04-24-11-34-48.jpg'
  },
  'kranarbejde-2': {
    title: 'Kranarbejde',
    metaTitle: 'Kranarbejde – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Nyhed: nu tilbyder vi kran arbejde med større kran med 35 tm med flyjib.',
    intro: 'Nyhed: nu tilbyder vi kran arbejde med større kran med 35 tm med flyjib\n\nF.eks.',
    items: [
      'Flytning af træer/rødder eller et legehus.',
      'Kraning af både jord,grus og sand med vores grab.',
      'Opkraning af tagsten mm.',
      'Kraning af diverse.'
    ],
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-03-28-15-09-48-1.jpg'
  },
  'grapning-af-slam-og-flydelag': {
    title: 'Grapning af slam og flydelag​',
    metaTitle: 'Grapning af slam og flydelag​ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi hjælper også gerne med at tømme din gylle tank for slam og flydelag med vores kran grab.',
    intro: 'Vi hjælper også gerne med at tømme din gylle tank for slam og flydelag med vores kran grab.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/skaermbillede-2024-04-02-kl-13-59-11.png'
  },
  'containerudlejning-service': {
    title: 'Containerudlejning/service',
    metaTitle: 'Containerudlejning/service – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Containerudlejning og service hos Vognmand & Entreprenør DBM aps',
    intro: 'Står du og mangler en container tilbyder vi også container til forskellige formål.',
    closing: 'Have affald, bygge affald eller lignede. Man kan også have en fast container stående til fast leje.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-03-03-09-57-45.jpg'
  },
  'kornkorsel': {
    title: 'Kornkørsel',
    metaTitle: 'Kornkørsel – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Når høsten melder sig står vi gerne for transporten af korn mm.',
    intro: 'Når høsten melder sig står vi gerne for transporten af korn mm.',
    closing: 'Vi har specielle containere vi benytter til dette formål.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/4-scaled.jpg'
  },
  'entreprenor-nedbrydningsopgaver': {
    title: 'Entreprenør- / nedbrydningsopgaver​',
    metaTitle: 'Entreprenør- / nedbrydningsopgaver​ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi udfører også nedbrydning af diverse bygninger, samt bortkørsel af diverse bygge materialer.',
    intro: 'Vi udfører også nedbrydning af diverse bygninger, samt bortkørsel af diverse bygge materialer.',
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2025-08-12-21-23-17.jpg'
  },
  'modtagelse-af-byggeaffald': {
    title: 'Modtagelse af byggeaffald',
    metaTitle: 'Modtagelse af byggeaffald – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Modtagelse af byggeaffald på pladsen på Hedemølle Industrivej 6, Bjerringbro.',
    intro: 'Nyhed',
    items: [
      'Beton/tegl brokker',
      'Blandede brokker',
      'Jord med brokker',
      'Rene beton fliser',
      'Blandet bygningsaffald til sortering',
      'Rent haveaffald/buske',
      'Rent sand og muldjord.'
    ],
    closing: 'Her finder du pladsen:\nHedemølle Industrivej 6, Bjerringbro\n\nKontakt os for pris',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/6-scaled_9d6aad7d.jpg'
  },
  'grus-udlaegnings-korsel': {
    title: 'Grus udlægnings kørsel',
    metaTitle: 'Grus udlægnings kørsel – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Er grusvejen fyldt med huller, så har vi en spiciallavet grus udlægning maskine til at lave grusvej.',
    intro: 'Er grusvejen fyldt med huller, så har vi en spiciallavet grus udlægning maskine til at lave grusvej.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/22-scaled.jpg'
  },
  'halm-korsel': {
    title: 'Halm kørsel',
    metaTitle: 'Halm kørsel – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Når høsten er ved at være i hus, står vi også gerne for transporten af halmen.',
    intro: 'Når høsten er ved at være i hus, står vi også gerne for transporten af halmen.',
    closing: 'Vi vil også gerne købe, sælge og formidle halm for jer.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/33-scaled.jpg'
  },
  'stammetraes-korsel': {
    title: 'Stammetræs kørsel',
    metaTitle: 'Stammetræs kørsel – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi transporterer også stammetræ når skoven er blevet justeret.',
    intro: 'Vi transporterer også stammetræ når skoven er blevet justeret',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/44-scaled.jpg'
  },
  'jernplade-leje': {
    title: 'Jernplade leje',
    metaTitle: 'Jernplade leje – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi lejer også jernplader/køreplader ud, når skoven eller lignende har brug for et jævnt køre lag.',
    intro: 'Vi lejer også jernplader/køreplader ud, når skoven eller lignende har brug for et jævnt køre lag',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/55-scaled.jpg'
  },
  'sorterings-anlaeg': {
    title: 'Sorterings anlæg',
    metaTitle: 'Sorterings anlæg – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vores sorterings anlæg kan lejes på dags basis til at sorter store mængder materiale som jord, brokker eller genbrugsmaterialer.',
    intro: 'Vores sorterings anlæg kan lejes på dags basis til at sorter store mængder materiale som jord, brokker eller genbrugsmaterialer.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/sorteringsanlaeg-hjemmeside-1-scaled.jpg'
  },
  'gylletrailer-39-m3': {
    title: 'Gylletrailer 39 m³',
    metaTitle: 'Gylletrailer 39 m³ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vi flytter gylle fra/til tanke eller buffer kasser.',
    intro: 'Vi flytter gylle fra/til tanke eller buffer kasser.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/gylletrailer-hjemmeside-1-scaled.jpg'
  },
  'buffer-kasse-100-m3': {
    title: 'Buffer kasse 100 m³',
    metaTitle: 'Buffer kasse 100 m³ – Vognmand & Entreprenør DBM aps',
    metaDesc: 'Vores 100 m³ buffer tank kan lejes på dags basis. Vi kan levere den lige hvor i ønsker eller i kan selv afhente den.',
    intro: 'Vores 100 m³ buffer tank kan lejes på dags basis.\nVi kan levere den lige hvor i ønsker eller i kan selv afhente den.',
    image: 'https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/buffer-kasse-hjemmeside-scaled.jpg'
  }
};

export default function ServiceDetailPage({ customSlug }) {
  const params = useParams();
  const slug = customSlug || params.slug || 'vognmandskorsel-2';
  const detail = SERVICE_DETAILS[slug] || SERVICE_DETAILS['vognmandskorsel-2'];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead title={detail.metaTitle} description={detail.metaDesc} />

      {/* Header Banner with Subpage Hero Image */}
      <section
        className="relative bg-cover bg-center bg-no-repeat text-white py-20 sm:py-32 px-4 sm:px-8 border-b-4 border-neutral-800 text-center flex items-center justify-center min-h-[350px] sm:min-h-[440px]"
        style={{
          backgroundImage: detail.image
            ? `url("${detail.image}")`
            : 'linear-gradient(to right, #111827, #1e293b, #111827)',
        }}
      >
        {/* No Dark Overlay */}

        <div className="relative z-10 max-w-4xl mx-auto drop-shadow-lg [text-shadow:_0_2px_10px_rgba(0,0,0,0.8)]">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-white">
            {detail.title}
          </h1>
          {detail.subtitle && (
            <p className="text-gray-200 text-base sm:text-xl mt-3 font-medium">
              {detail.subtitle}
            </p>
          )}
          <div className="mt-6">
            <Link
              to="/kontakt/"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3.5 rounded text-sm uppercase tracking-wider border border-white/30 transition-colors shadow-lg"
            >
              Kontakt os her
            </Link>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 px-4 sm:px-8 max-w-7xl mx-auto">
        <div className="bg-white">
          
          <div className="space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed font-normal mb-8">
            {detail.intro && (
              <div className="font-semibold text-lg text-gray-900 whitespace-pre-line">
                {detail.intro}
              </div>
            )}

            {detail.items && detail.items.length > 0 && (
              <ul className="space-y-2 list-disc list-inside text-gray-700 my-4 pl-2">
                {detail.items.map((item, idx) => (
                  <li key={idx} className="leading-relaxed">
                    {item}
                  </li>
                ))}
              </ul>
            )}

            {detail.closing && (
              <div className="whitespace-pre-line font-medium text-gray-800 pt-2">
                {detail.closing}
              </div>
            )}
          </div>

          <div className="pt-6 border-t border-gray-200 flex flex-wrap gap-4 items-center justify-between">
            <Link
              to="/kontakt/"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3 rounded uppercase tracking-wider text-xs border border-white/20 transition-colors shadow-md"
            >
              Kontakt os her
            </Link>

            <Link
              to="/ydelser/"
              className="text-xs font-bold text-gray-600 hover:text-gray-900 uppercase tracking-wider flex items-center space-x-1"
            >
              <span>← Se alle ydelser</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Bottom Cards for stobningsarbejde/anlaegsopgaver/kloak-og-jordarbejde */}
      {detail.showBottomCards && (
        <section className="py-12 bg-gray-50 border-t border-gray-200 px-4 sm:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center uppercase tracking-tight">
              Læs mere
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              
              <div className="bg-white rounded shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                <img
                  src="https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/l-top-view-large-freight-transporter-semi-tru-2023-11-27-05-36-38-utc-scaled.jpg"
                  alt="Maskiner"
                  className="w-full h-48 object-cover"
                />
                <div className="p-5 flex-1 flex flex-col justify-between text-center">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Maskiner</h3>
                    <p className="text-sm text-gray-600 mb-4">
                      Vi råder over en stor maskinpark, som sikrer fleksibilitet.
                    </p>
                  </div>
                  <Link
                    to="/maskiner/"
                    className="inline-block bg-gray-900 hover:bg-black text-white text-xs font-bold py-2 px-4 rounded uppercase transition-colors"
                  >
                    Se mere her
                  </Link>
                </div>
              </div>

              <div className="bg-white rounded shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                <img
                  src="https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/c-front-view-big-long-heavy-semi-treailer-tru-2023-11-27-05-35-16-utc-scaled.jpg"
                  alt="Ydelser"
                  className="w-full h-48 object-cover"
                />
                <div className="p-5 flex-1 flex flex-col justify-between text-center">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Ydelser</h3>
                    <p className="text-sm text-gray-600 mb-4">
                      Vi hjælper med alle typer opgaver, store som små.
                    </p>
                  </div>
                  <Link
                    to="/ydelser/"
                    className="inline-block bg-gray-900 hover:bg-black text-white text-xs font-bold py-2 px-4 rounded uppercase transition-colors"
                  >
                    Se mere her
                  </Link>
                </div>
              </div>

              <div className="bg-white rounded shadow-sm border border-gray-200 overflow-hidden flex flex-col">
                <img
                  src="https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/l-view-of-cargo-truck-driving-on-highway-haul-2023-11-27-05-37-22-utc-scaled.jpg"
                  alt="Om os"
                  className="w-full h-48 object-cover"
                />
                <div className="p-5 flex-1 flex flex-col justify-between text-center">
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Om os</h3>
                    <p className="text-sm text-gray-600 mb-4">
                      Vi udfører altid vores arbejde med præcision.
                    </p>
                  </div>
                  <Link
                    to="/om-os/"
                    className="inline-block bg-gray-900 hover:bg-black text-white text-xs font-bold py-2 px-4 rounded uppercase transition-colors"
                  >
                    Læs mere her
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </section>
      )}
    </div>
  );
}
